export default function IconsExplainedModal() {
  return (
    <div className="modal fade mt-5" id="icons-explained-modal" tabIndex={-1} role="dialog" aria-labelledby="icons-explained-modal-label" aria-hidden="true">
      <div className="modal-dialog" role="document">
        <div className="modal-content">
          <div className="modal-header text-center">
            <h2 id="icons-explained-modal-label" className="modal-title w-100">
              <i className="fa-solid fa-circle-info mr-2"></i> Icons Explained
            </h2>
            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body">
            <>
              <p>Players with icons in the top right are considered 'promos'.</p>

              <h3 style={{fontSize: '40px'}}>🤞🤑</h3>
              <p>The 🤞 pay out higher. Easier plays with the 🤑 pay less.</p>

              <h3 style={{fontSize: '40px'}}>🍀</h3>
              <p>Players with the 🍀 are limited time offers that are nearly a guarantee pick.</p>
            </>
          </div>
        </div>
      </div>
    </div>
  )

}